import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {UserGroupDocumentTitle} from 'src/app/user-groups/userGroupHelpers';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import UserGroupForm from 'src/app/user-groups/UserGroupForm';

export const CreateUserGroupPage = () => {
  useSetDocumentTitle(UserGroupDocumentTitle);

  return (
    <ContentWrapper>
      <UserGroupForm id={undefined} mode="create" />
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.UserGroupCreate(':view'),
  element: <CreateUserGroupPage />,
  module: ModuleEnum.UserGroups,
  operation: PermissionOperationEnum.Create,
  isPrivate: true,
  allowGlobalAdminBypass: true,
});

export default CreateUserGroupPage;
